<template>
    <div>
        <create-task v-if="isLoaded" v-model="isLoaded" :task-sub-types="taskTypes" :task-assignees="taskAssignees" :todoData="todoData"/>
    </div>
</template>

<script type="text/babel">
import api from '../../../assets/api.js';
import { mapGetters } from 'vuex';

export default {
    name: "CreateTodo",
    components: {
      'create-task': () => import('./CreateTask.vue'),
    },
    props: ['isCreateTodo', 'taskBucket', 'taskType', 'lease', 'lease_id', 'contact_id', 'due_date'],
    data() {
        return {
            isLoaded: false,
            taskTypes: {},
            taskAssignees: [],
            todoData: {},
            taskTypesData: []
        }
    },
    async created() {
        this.isLoaded = JSON.parse(JSON.stringify(this.isCreateTodo))
        this.fetchAssignees();
        await this.fetchTaskTypes();
        let taskTypeFound = {};
        let filteredTaskTypesData = [];
        if(this.taskBucket != undefined && this.taskType == 'moveout_prepare_space') {
            filteredTaskTypesData = this.getAllowedTaskTypes[this.taskBucket?.toLowerCase()];
            taskTypeFound = filteredTaskTypesData.find(i => i.slug == 'other');
        } else {
            this.taskTypesData.forEach(item => {
                if(item.slug == this.taskType) {
                    taskTypeFound = item;
                }
            });
        }
        switch (this.taskType) {
            case 'reservation_follow_up':
            case 'lead_follow_up':
                this.todoData = {
                    todoAssociation: false,
                    todoSubType: taskTypeFound?.id,
                    todoType: taskTypeFound?.label.toLowerCase(),
                    todoAssociationType: this.lease_id ? 3 : this.contact_id ? 4 : 0,
                    todoAssociationList: this.contact_id || this.lease_id ? [{id: this.contact_id, lease_id: this.lease_id}] : [],
                }
                break;
            case 'move_out':
                this.todoData = {
                    todoAssociation: false,
                    todoSubType: taskTypeFound?.id,
                    todoTitle: 'Intent to Move-Out',
                    todoAssociationType: this.contact_id ? 3 : 0,
                    todoAssociationList: this.contact_id ? [{id: this.contact_id, lease_id: this.lease_id}] : [],
                    todoType: taskTypeFound?.label.toLowerCase(),
                    todoDueDate: this.due_date,
                    todoHideHotTask: true,
                }
                break;
            case 'clean_&_prepare_space':
                this.todoData = {
                    todoAssociation: false,
                    todoSubType: taskTypeFound?.id,
                    todoTitle: "Schedule Inspection on Space # " + this.$props.lease?.Unit?.number,
                    todoAssociationType: this.lease_id ? 3 : this.contact_id ? 4 : 0,
                    todoAssociationList: this.contact_id || this.lease_id ? [{id: this.contact_id, lease_id: this.lease_id}] : [],
                    todoType: taskTypeFound?.label.toLowerCase(),
                }
                break;
            case 'moveout_prepare_space':
                this.todoData = {
                    todoAssociation: false,
                    todoSubType: taskTypeFound?.id,
                    todoTitle: "Schedule Inspection on Space # " + this.$props.lease?.Unit?.number,
                    todoAssociationType: this.lease_id ? 3 : this.contact_id ? 4 : 0,
                    todoAssociationList: this.contact_id || this.lease_id ? [{id: this.contact_id, lease_id: this.lease_id}] : [],
                    todoType: taskTypeFound?.label.toLowerCase(),
                }
                break;
            case 'collection_calls':
                this.todoData = {
                    todoAssociation: false,
                    todoSubType: taskTypeFound?.id,
                    todoType: taskTypeFound?.label.toLowerCase(),
                    todoAssociationType: this.lease_id ? 3 : this.contact_id ? 4 : 0,
                    todoAssociationList: this.contact_id || this.lease_id ? [{id: this.contact_id, lease_id: this.lease_id}] : [],
                }
                break;
            default:
                this.todoData = {} 
                break;
        }
    },
    computed: {
        ...mapGetters({
            getAllowedTaskTypes: 'taskCenterStore/getAllowedTaskTypes',
        }),
    },
    watch: {
        isLoaded() {
            if(!this.isLoaded) {
                this.$emit('closeCreateTodo', this.isLoaded);
            }
        },
    },
    methods: {
        async fetchTaskTypes() {
            let response = await api.get(this, api.TASKS_CENTER + 'task_types');
            this.taskTypesData = response?.task_types;
            let allowedTypes = {
                "Lead": ['Cart Abandonment', 'Coupon Clicks', 'Hot Lead - Pending Website Move-In', 'Lead Follow-Up', 'New Reservation', 'New Web Lead', 'New Web Reservation', 'Pending Move In', 'Reservation Follow-Up', 'Website Reservation Failure','Other'],
                "Delinquency": ['Auction Day', 'Auction Notice Advertisement', 'Auction Payment', 'Collection Calls', 'Cut Lock and Space Inventory', 'Lien Notice', 'Lien Notices', 'Lock Cut', 'Lock Cut Inventory', 'Lock Removal', 'Overlock Space', 'Schedule Auction','Other'],
                "Operations": ['Approve Rate Change', 'Generated Documents', 'Move Out', 'Pending Transfer', 'Rental Lease', 'Review Rate Change Notification', 'Welcome Letter', 'Other'],
                "Maintenance": ["Clean & Prepare Space","Other"]
            }

            Object.keys(allowedTypes).forEach(keyItem => {
                allowedTypes[keyItem].forEach(atItem => {
                    let foundType = null;
                    if (atItem === 'Other') {
                        foundType = response.task_types.find(item => item.name === atItem && item.label === keyItem);
                    } else foundType = response.task_types.find(item => item.name === atItem)
                    if(foundType) {
                        if (this.taskTypes[keyItem.toLowerCase()]) {
                            this.taskTypes[keyItem.toLowerCase()].push(foundType)
                        } else this.taskTypes[keyItem.toLowerCase()] = [foundType]
                    }
                })
            })
        },
        async fetchAssignees(){
            let usersRequest = api.get(this, api.ADMIN + 'active/users');
            let rolesRequest = api.get(this, api.ROLES);
            Promise.all([usersRequest, rolesRequest])
            .then(responses => {
                this.taskAssignees = [...responses[0].admins.map( item => { 
                    return {
                        id: item.contact_id,
                        name: item.first + ' ' + item.last,
                        is_admin: true
                    }
                }), ...responses[1].roles.map( item => {
                    return {
                        id: item.id,
                        name: item.name,
                        is_role: true
                    }
                })];
            })
        },
    }
}
</script>

<style scoped>

</style>